import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IesSummary } from '../models/ies-summary.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ReportService {
  private readonly apiUrl = `${environment.apiUrl}`;

  constructor(private http: HttpClient) {}

  /** Liste des IES racines avec sigle + code pour le rapport. */
  getRootIes(): Observable<IesSummary[]> {
    return this.http.get<IesSummary[]>(`${this.apiUrl}/groups/ies-with-codes`);
  }

  /** Télécharge le fichier Excel du bilan pour une IES. */
  downloadApplicationsAdminsReport(iesCode: string): Observable<Blob> {
    const params = new HttpParams().set('iesCode', iesCode);
    return this.http.get(`${this.apiUrl}/reports/applications-admins`, {
      params,
      responseType: 'blob'
    });
  }
}